(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-carousel"]) return;
  try {
    
  class BannerCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentSlide = 0;
      this.slides = this.querySelectorAll('.banner-carousel__slide');
      this.totalSlides = this.slides.length;
      this.autoplayDelay = 8000;
      this.autoplayTimer = null;
      this.transitionTimer = null;
      
      this.init();
    }

    init() {
      // Only setup navigation and autoplay if there's more than one slide
      if (this.totalSlides > 1) {
        // Setup navigation buttons
        const prevButton = this.querySelector('[data-direction="prev"]');
        const nextButton = this.querySelector('[data-direction="next"]');
        
        if (prevButton) {
          prevButton.addEventListener('click', () => this.navigate('prev'));
        }
        
        if (nextButton) {
          nextButton.addEventListener('click', () => this.navigate('next'));
        }

        // Start autoplay
        this.startAutoplay();

        // Pause autoplay on hover
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      } else {
        // Hide navigation buttons if only one slide
        const prevButton = this.querySelector('[data-direction="prev"]');
        const nextButton = this.querySelector('[data-direction="next"]');
        
        if (prevButton) {
          prevButton.style.display = 'none';
        }
        
        if (nextButton) {
          nextButton.style.display = 'none';
        }
      }

      this.setupSmoothScrollToSections();
    }

    // Vale para qualquer link do carrossel que aponte para uma âncora da própria página
    // (#nossos-produtos nos CTAs e #combos no banner inteiro do Combo). Fora da home, ou
    // se a âncora não existir na página, o link segue como navegação normal.
    setupSmoothScrollToSections() {
      const links = this.querySelectorAll('a[href*="#"]');
      links.forEach((link) => {
        link.addEventListener('click', (e) => {
          let linkUrl;
          try {
            linkUrl = new URL(link.href, window.location.href);
          } catch (_) {
            return;
          }

          const hash = linkUrl.hash ? linkUrl.hash.slice(1) : '';
          if (!hash) return;

          const section = document.getElementById(hash);
          const target =
            (section && section.querySelector('.product-carousel__title')) ||
            section;
          if (!target) return;

          const normalize = (p) => {
            const s = p || '/';
            return s.length > 1 && s.endsWith('/') ? s.slice(0, -1) : s;
          };

          if (normalize(linkUrl.pathname) !== normalize(window.location.pathname)) {
            return;
          }

          e.preventDefault();
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({
            behavior: reduceMotion ? 'auto' : 'smooth',
            block: 'start',
          });
          if (window.history && window.history.replaceState) {
            history.replaceState(null, '', '#' + hash);
          }
        });
      });
    }

    navigate(direction) {
      // Calculate next slide
      if (direction === 'next') {
        this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
      } else {
        this.currentSlide = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
      }
      
      // Add active class to new slide first (cross-fade)
      this.slides[this.currentSlide].classList.add('banner-carousel__slide--active');
      this.slides[this.currentSlide].style.zIndex = '2';
      
      // Wait for transition to complete before removing previous slide.
      //
      // Uma navegação nova cancela a limpeza pendente da anterior e desativa todos os
      // slides menos o atual. Com as setas manuais, dois cliques seguidos faziam o
      // timeout antigo (agendado com o índice de antes) tirar o --active do slide que
      // tinha acabado de entrar, e o banner ficava em branco até o próximo autoplay.
      if (this.transitionTimer) {
        clearTimeout(this.transitionTimer);
      }

      this.transitionTimer = setTimeout(() => {
        this.slides.forEach((slide, index) => {
          if (index === this.currentSlide) return;
          slide.classList.remove('banner-carousel__slide--active');
          slide.style.zIndex = '1';
        });
        this.transitionTimer = null;
      }, 1200); // Match transition duration
      
      // Restart autoplay only for manual navigation
      if (direction !== 'auto') {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    startAutoplay() {
      this.stopAutoplay(); // Clear any existing timer
      this.autoplayTimer = setInterval(() => {
        this.navigate('auto');
      }, this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  customElements.define('banner-carousel', BannerCarousel);

  // Initialize carousel
  document.addEventListener('DOMContentLoaded', () => {
    const carousel = document.querySelector('[data-banner-carousel]');
    if (carousel && !customElements.get('banner-carousel')) {
      // Fallback if custom elements not supported
      const bannerCarousel = new BannerCarousel();
      Object.setPrototypeOf(carousel, BannerCarousel.prototype);
      BannerCarousel.call(carousel);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["restock-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-restock-scroll]');
      if (!link) return;

      var hash = link.getAttribute('href') || '';
      if (hash.charAt(0) !== '#') return;

      var target = document.getElementById(hash.slice(1));
      if (!target) return;

      event.preventDefault();
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });

      if (history && typeof history.pushState === 'function') {
        history.pushState(null, '', hash);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
